import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidadorServiceService } from '../../services/validador-service.service';
import { MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Location } from '@angular/common';
import { Validador } from '../../models/validador-model';
import { ModelHelpers } from '../../models/ModelHelpers';
import { TipoInmuebleService } from '../../services/tipo-inmueble.service';
import { AdminUsuario } from '../../models/AdminUsuario';
import { UsuariosService } from '../../services/usuarios.service';

@Component({
  selector: 'app-validador-edit',
  templateUrl: './validador-edit.component.html',
  styleUrls: ['./validador-edit.component.scss']
})
export class ValidadorEditComponent implements OnInit {

  validadorForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  isModal: boolean;
  errorMessage: any;
  tipologiaList: any = [];
  users: AdminUsuario[] = [];
  private dataLoaded = false;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private _validadorService: ValidadorServiceService,
    private _authService: AuthService, private _router: Router, public dialogRef: MatDialogRef<ValidadorServiceService>,
    private _location: Location, private _tipoInmueblesService: TipoInmuebleService, private _usuariosService: UsuariosService) {
    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.validadorForm = this._fb.group({
      id: 0,
      nombreCompleto: ['', [Validators.required]],
      email: ['', [Validators.required]],
      ciudad: [''],
      tipologiaID: [''],
      visitador: [false],
      activo: [true],
      userID: ['']
    });
  }


  ngOnInit() {
    this.loadData();
    this.loadCombo();
  }

  get nombreCompleto() {
    return this.validadorForm.get('nombreCompleto');
  }

  get email() {
    return this.validadorForm.get('email');
  }

  loadData() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      this._validadorService.getValidadorById(this.id)
        .subscribe(resp => {
          this.validadorForm.setValue(resp);
        }, error => { this.errorMessage = error; });
    } else {
      this.isNewElement = true;
    }
  }

  loadCombo() {
    this._tipoInmueblesService.getTipoInmuebles(false).subscribe(data => this.tipologiaList = data);
    this._usuariosService.getAllUsers().subscribe((data: AdminUsuario[]) => {
      this.users = data;
      this.dataLoaded = true;
      // Después de cargar los datos, verifica si hay un usuario seleccionado y muestra su displayName
      this.showSelectedUser();
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  save() {
    if (!this.validadorForm.valid) {
      return;
    }
    let model = new Validador();
    ModelHelpers.copyFromForm(this.validadorForm.value, model);
    console.log(model);

    if (this.isNewElement) {
      this._validadorService.post(this.validadorForm.value)
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
        }, error => this.errorMessage = error);
    } else {
      this._validadorService.put(this.validadorForm.value)
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
        }, error => this.errorMessage = error);
    }
  }

  displayFnUser = (item: any) => {
    if (!this.dataLoaded || !this.users) {
      return ''; // Valor por defecto
    }

    const user = this.users.find(user => user.id === item);
    return user ? user.displayName : '';
  }

  onClearUser() {
    this.validadorForm.patchValue({
      userID: ''
    })
  }

  showSelectedUser() {
    // Obtén el valor actual del control 'userID'
    const selectedUserId = this.validadorForm.get('userID').value;

    // Encuentra el usuario correspondiente
    const selectedUser = this.users.find(user => user.id === selectedUserId).id;

    // Si se encuentra el usuario, muestra su displayName
    if (selectedUser) {
      this.validadorForm.get('userID').setValue(selectedUser);
    }

  }


}
